import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import Breadcrumb from "../common/breadcrumb";
import { Helmet } from "react-helmet";
import { Event } from "../Tracking/Tracking";
import backend from "../../api";
import { PrintComponents } from "react-print-components";
import ClipLoader from "react-spinners/ClipLoader";

const ParentConsentForm = () => {
  const [state, setState] = useState(null);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      setLoading(true);
      backend
        .get(`/consentform?_id=${id}`)
        .then(({ data }) => {
          setState(data.data[0]);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
        });
    }
  }, [id]);

  const downloadPdf = () => {
    Event("Download", "PDF", "Parent Consent From");
  };
  return loading ? (
    <div className="dashboard">
      <div className="box-account box-info mt-3">
        <div className="my-5 row justify-content-center">
          <ClipLoader color={"#000000"} loading={loading} size={60} />
        </div>
      </div>
    </div>
  ) : (
    <div>
      <div>
        <Helmet>
          <title>eksplode! | Parent Consent Form</title>
        </Helmet>
        <Breadcrumb title={"Form"} />
        {/*about section*/}
        <section className="about-page  section-b-space">
          <div className="container ">
            <div className="row">
              <div className="col-12 " id="divToDowload">
                <strong>
                  <p className="text-center">
                    Parlay Roial, LLC <br /> PARENTAL CONSENT FORM
                    <br /> FOR ENTRY IN EKSPLODE™ VIDEO AD CONTEST <br />
                    BY A MINOR
                  </p>
                </strong>
                <br />
                <h4>Name of Contest Entrant: {state && state.entrant_name}</h4>

                <h4>
                  Email address of Contest Entrant:{" "}
                  {state && state.entrant_email}
                </h4>

                <h4>
                  Birthdate of Entrant:{" "}
                  {state && new Date(state.entrant_DOB).toLocaleDateString()}
                </h4>

                <h4>
                  Name of Parent or Legal Guardian:{" "}
                  {state && state.guardian_name}{" "}
                </h4>

                <h4>
                  Email address of Parent: {state && state.guardian_name}{" "}
                </h4>

                <p>
                  <strong>Verification of Consent:</strong>
                  In order to permit the entrant identified above (referred to
                  as “Entrant”) to enter the Eksplode™ Video Ad Contest (VAC),
                  the parent or legal guardian identified above (referred to as
                  “Parent”) must print out, sign and date this Parental Consent
                  Form and send a scanned copy to Parlay Roial at the following
                  email address: ____________________.
                </p>
                <p>
                  <small>
                    By signing and dating this Parental Consent Form where
                    indicated below, the parent or legal guardian (“Parent”) of
                    the contest entrant named above (“Entrant”) hereby
                    acknowledges and agrees as follows.
                  </small>
                </p>

                <ol className="text-left">
                  <li>
                    <p>
                      <small>
                        <strong>1. Age of Entrant.</strong>
                        The Entrant is 13 years of age or older but under the
                        age of 18.
                      </small>
                    </p>
                  </li>
                  <br />
                  <li>
                    <p>
                      <small>
                        <strong>2. Authority of Parent.</strong>
                        The Parent is the parent or legal guardian of the
                        Entrant.
                      </small>
                    </p>
                  </li>

                  <li>
                    <p>
                      <small>
                        <strong>3. Authorization.</strong>
                        Parent authorizes the Entrant to enter the VAC according
                        to the Official Rules and the Terms of Use and Privacy
                        Policy as posted at Parlay Roial’s website.
                      </small>
                    </p>
                  </li>
                  <li>
                    <p>
                      <small>
                        <strong>4. Consent.</strong>
                        Parent consents to the collection of personal data from
                        the Entrant, and the use of the Entrant’s personal data
                        by Parlay Roial, all subject to the Contest Rules, the
                        Terms of Use and the Privacy Policy posted at the
                        contest website.
                      </small>
                    </p>
                  </li>
                  <li>
                    <p>
                      <small>
                        <strong>5. Ratification by Parent.</strong>
                        The undersigned Parent, on behalf herself or himself and
                        on behalf of the Entrant, hereby acknowledges and agrees
                        as follows:
                        <ol>
                          <li>
                            (a) Parent has read and understood and hereby
                            ratifies and approves the Contest Rules, the Terms
                            of Use and the Privacy Policy.{" "}
                          </li>
                        </ol>
                        <ol>
                          <li>
                            (b) The Parent is the parent or legal guardian of
                            the Entrant.
                          </li>
                        </ol>
                        <ol>
                          <li>
                            (c)Parent shall generally cooperate with Parlay
                            Roial in order to give full force and effect to this
                            Parental Consent. By way of example, if requested by
                            Parlay Roial, Parent will cooperate with Publisher
                            in obtaining court approval of this Parental Consent
                            Form as provided for under applicable law.
                          </li>
                        </ol>
                        <ol>
                          <li>
                            (d) Entrant and Parent acknowledge and agree that
                            Parlay Roial intends and is entitled to rely on this
                            Parental Consent Form and would not have accepted an
                            entry from the Entrant if the Parental Consent Form
                            had not been signed and returned.
                          </li>
                        </ol>
                      </small>
                    </p>
                  </li>
                </ol>
                <div className="row">
                  <div className="col">
                    <p>
                      <small>Agreed and confirmed:</small>
                    </p>
                  </div>
                  <div className="col">
                    {/* <strong> <hr style={{height:"1px",border:none",color:"#333",}}/></strong> */}
                    <br />
                    <hr />
                    <p>Parent</p>
                    <br />
                    <br />
                    <strong>
                      {" "}
                      <hr />
                    </strong>
                    <p>Date</p>
                  </div>
                </div>
              </div>
              <PrintComponents
                trigger={
                  <button className="btn btn-solid" onClick={downloadPdf()}>
                    <i className="fas fa-file-pdf ml-1 fa-2x"></i> Download Form
                  </button>
                }
              >
                <section className="about-page  section-b-space">
                  <div className="container ">
                    <div className="row">
                      <div className="col-12 " id="divToDowload">
                        <strong>
                          <p className="text-center">
                            Parlay Roial, LLC <br /> PARENTAL CONSENT FORM
                            <br /> FOR ENTRY IN EKSPLODE™ VIDEO AD CONTEST{" "}
                            <br />
                            BY A MINOR
                          </p>
                        </strong>
                        <br />
                        <h4>
                          Name of Contest Entrant: {state && state.entrant_name}
                        </h4>

                        <h4>
                          Email address of Contest Entrant:{" "}
                          {state && state.entrant_email}
                        </h4>

                        <h4>
                          Birthdate of Entrant:{" "}
                          {state &&
                            new Date(state.entrant_DOB).toLocaleDateString()}
                        </h4>

                        <h4>
                          Name of Parent or Legal Guardian:{" "}
                          {state && state.guardian_name}{" "}
                        </h4>

                        <h4>
                          Email address of Parent:{" "}
                          {state && state.guardian_email}{" "}
                        </h4>

                        <p>
                          <strong>Verification of Consent:</strong>
                          Verification of Consent: In order to permit the
                          entrant identified above (referred to as “Entrant”) to
                          enter the Eksplode™ Video Ad Contest (VAC), the parent
                          or legal guardian identified above (referred to as
                          “Parent”) must print out, sign and date this Parental
                          Consent Form and send a scanned copy to Parlay Roial
                          at the following email address: ____________________.
                        </p>
                        <p>
                          <small>
                            By signing and dating this Parental Consent Form
                            where indicated below, the parent or legal guardian
                            (“Parent”) of the contest entrant named above
                            (“Entrant”) hereby acknowledges and agrees as
                            follows.
                          </small>
                        </p>

                        <ol className="text-left">
                          <li>
                            <p>
                              <small>
                                <strong>1. Age of Entrant.</strong>
                                The Entrant is 13 years of age or older but
                                under the age of 18.
                              </small>
                            </p>
                          </li>
                          <br />
                          <li>
                            <p>
                              <small>
                                <strong>2. Authority of Parent.</strong>
                                The Parent is the parent or legal guardian of
                                the Entrant.
                              </small>
                            </p>
                          </li>
                          <br />
                          <li>
                            <p>
                              <small>
                                <strong>3. Authorization.</strong>
                                Parent authorizes the Entrant to enter the VAC
                                according to the Official Rules and the Terms of
                                Use and Privacy Policy as posted at Parlay
                                Roial’s website.
                              </small>
                            </p>
                          </li>
                          <br />

                          <li>
                            <p>
                              <small>
                                <strong>4. Consent.</strong>
                                Parent consents to the collection of personal
                                data from the Entrant, and the use of the
                                Entrant’s personal data by Parlay Roial, all
                                subject to the Contest Rules, the Terms of Use
                                and the Privacy Policy posted at the contest
                                website.
                              </small>
                            </p>
                          </li>
                          <br />

                          <li>
                            <p>
                              <small>
                                <strong>5. Ratification by Parent.</strong>
                                The undersigned Parent, on behalf herself or
                                himself and on behalf of the Entrant, hereby
                                acknowledges and agrees as follows:
                                <ol>
                                  <li>
                                    (a) Parent has read and understood and
                                    hereby ratifies and approves the Contest
                                    Rules, the Terms of Use and the Privacy
                                    Policy.{" "}
                                  </li>
                                </ol>
                                <ol>
                                  <li>
                                    (b) The Parent is the parent or legal
                                    guardian of the Entrant.
                                  </li>
                                  <br />
                                </ol>
                                <ol>
                                  <li>
                                    (c)Parent shall generally cooperate with
                                    Parlay Roial in order to give full force and
                                    effect to this Parental Consent. By way of
                                    example, if requested by Parlay Roial,
                                    Parent will cooperate with Publisher in
                                    obtaining court approval of this Parental
                                    Consent Form as provided for under
                                    applicable law.
                                  </li>
                                  <br />
                                </ol>
                                <ol>
                                  <li>
                                    (d) Entrant and Parent acknowledge and agree
                                    that Parlay Roial intends and is entitled to
                                    rely on this Parental Consent Form and would
                                    not have accepted an entry from the Entrant
                                    if the Parental Consent Form had not been
                                    signed and returned.
                                  </li>
                                  <br />
                                </ol>
                              </small>
                            </p>
                          </li>
                        </ol>
                        <div className="row">
                          <div className="col">
                            <p>
                              <small>Agreed and confirmed:</small>
                            </p>
                          </div>
                          <div className="col">
                            {/* <strong> <hr style={{height:"1px",border:none",color:"#333",}}/></strong> */}
                            <br />
                            <hr />
                            <p>Parent</p>
                            <br />
                            <br />
                            <strong>
                              {" "}
                              <hr />
                            </strong>
                            <p>Date</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <br />
                  </div>
                </section>
              </PrintComponents>
            </div>
            <br />
          </div>
        </section>
      </div>
    </div>
  );
};

export default ParentConsentForm;
